<template>
  <div class="layout-compare" :key="componentKey">
    <div class="container">
      <div class="title font-palantino"><slot name="title"></slot></div>
      <!--  -->
      <div class="links">
        <!--  -->
        <div
            :class="[{ active: currentCategory === index }]"
            v-for="(category, index) in categories"
            :key="index"
            class="s-16 w-500"
            @click="currentCategory = index"
        >
          {{ category }}
        </div>
      </div>
      <!--  -->
      <div class="body">
        <div class="header layout">
          <div class="side ui-switcher-wrapper">
            <ui-switcher :values="[1,2]" v-model="currentTab" :options="tabs.map(t => t.name)"></ui-switcher>
          </div>
          <div class="items-wrapper">
            <div class="items" :style="{ transform: `translate3d(calc(var(--size) * -1 * ${currentIndex}),0,0)` }">
              <div class="item" v-for="(item, index) in products" :key="index">
                <div class="image">
                  <a :href="item.url" :title="item.name"><img :src="item.image" class="abs" :alt="item.name" /></a>
                </div>
                <div class="name s-18 w-600"><a :href="item.url" :title="item.name">{{ item.name }}</a></div>
                <div class="uppercase price s-14 w-500">
                  От {{ item.price.toLocaleString() }}
                  <span class="ruble">₽</span>
                </div>
                <div class="only-mobile">
                  <div class="mobile-rows">
                    <div
                        v-if="isOnlyDifferences ? isRowWithDifference(key) : true"
                        class="row"
                        v-for="(value, key, fieldIndex) in item.fields"
                        :key="fieldIndex"
                    >
                      <div class="label s-12 w-500">{{ key }}</div>
                      <div class="value">{{ value }}</div>
                    </div>
                  </div>
<!--                  <div class="button has-icon-left">
                    <icon-bag></icon-bag>
                    <span class="s-16 w-500">В корзину</span>
                  </div>-->
                  <div @click="delCompare(item)" class="underline cursor-pointer remove s-16 w-500">Убрать из сравнения</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--  -->
        <div class="rows">
          <div
              v-if="isOnlyDifferences ? isRowWithDifference(field) : true"
              class="row layout"
              v-for="(field, index) in fields"
              :key="index"
          >
            <div class="field-name">
              <div class="s-14">{{ field }}</div>
            </div>
            <div class="items-wrapper">
              <div
                  class="row-items items"
                  :style="{ transform: `translate3d(calc(var(--size) * -1 * ${currentIndex}),0,0)` }"
              >
                <div class="item" v-for="(item, index) in products" :key="index">
                  <div class="label s-12 w-500">{{ field }}</div>
                  <div class="value">{{ item.fields[field] }}</div>
                  <!--  -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--  -->
        <div class="buttons layout">
          <div class="side"></div>
          <div class="items-wrapper">
            <div class="items" :style="{ transform: `translate3d(calc(var(--size) * -1 * ${currentIndex}),0,0)` }">
              <div class="item" v-for="(item, index) in products" :key="index">
<!--                <div class="button has-icon-left">
                  <icon-bag></icon-bag>
                  <span class="s-16 w-500">В корзину</span>
                </div>-->
                <div @click="delCompare(item)" class="underline cursor-pointer remove s-16 w-500">Убрать из сравнения</div>
              </div>
            </div>
          </div>
        </div>

        <!--  -->
        <div class="navigation" v-if="products.length > 3">
          <ui-arrow-button @click="prev" to="left"></ui-arrow-button>
          <ui-arrow-button @click="next" to="right"></ui-arrow-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    compare: {},
    arfields: {}
  },
  data() {
    return {
      currentIndex: 0,
      currentCategory: 0,
      componentKey: 0,
      currentTab: 'Все характеристики',
      tabs: [
        {
          name: 'Все характеристики'
        },
        {
          name: 'Только отличия'
        }
      ],
      site_id: this.$store.state.siteid,
      //compare: ""//window.__data__.compare
    }
  },
  computed: {
    currentTabIndex() {
      return this.tabs.findIndex(t => t.name === this.currentTab)
    },
    isOnlyDifferences() {
      return this.currentTabIndex === 1
    },
    fields() {
      return Object.keys(this.arfields[this.currentCategory])
    },
    categories() {
      return [...new Set(this.compare.items.map(item => item.category))]
    },
    products() {
      return this.compare.items.filter(item => item.category === this.categories[this.currentCategory])
      // return this.compare.items
    }
  },
  methods: {
    isRowWithDifference(fieldName) {
      return this.compare.items.some(item => {
        return typeof item.fields[fieldName] !== "undefined" && item.fields[fieldName] !== this.arfields[this.currentCategory][fieldName]
      })
    },
    next() {
      if (this.currentIndex < this.products.length - 3) {
        this.currentIndex++
      } else {
        this.currentIndex = 0
      }
    },
    prev() {
      if (this.currentIndex > 0) {
        this.currentIndex--
      } else {
        this.currentIndex = this.products.length - 3
      }
    },
    delCompare(item){
      var cookieCompare = this.$cookie.get('compare');
      var compareJson = {};
      if( cookieCompare ){
        compareJson = JSON.parse(cookieCompare);
        compareJson[this.site_id][item.iblock_id] = compareJson[this.site_id][item.iblock_id].filter((n) => {return n != item.id});
        let index = this.compare.items.findIndex(el => el.id === item.id);
        let indexProducts = this.compare.items.findIndex(el => el.id === item.id);
        this.compare.items.splice(index, 1);
        this.products.splice(indexProducts, 1);
        this.componentKey += 1;
        this.$cookie.set('compare', JSON.stringify(compareJson))
        var cuntCompare = 0;
        for (var key in compareJson[this.site_id]) {
          cuntCompare = cuntCompare + compareJson[this.site_id][key].length;
        }
        this.$bus.$emit("compare", cuntCompare);
      }
    },
  },
  components: {
    uiSwitcher: () => import('@/components/ui/ui-switcher.vue'),
    uiButton: () => import('@/components/ui/ui-button.vue'),
    uiArrowButton: () => import('@/components/ui/ui-arrow-button.vue'),
    iconBag: () => import('@/components/icon/icon-bag.vue')
  }
}
</script>

<style lang="scss" scoped>
.layout-compare {
  text-align: center;
  padding: 3em 0;
  --size: 250px;
}
.container{
  padding-left: 20px;
}
.title {
  font-size: 4.68em;
}
.subtitle {
  margin-top: 1em;
}
.links {
  margin-top: 2em;
  & > * {
    display: inline-block;
    padding: 0.8em 1.5em;
    cursor: pointer;
    border-radius: 100px;
    border: 1px solid var(--light);
    margin: 0.1em;
    transition: 0.3s;
    &:hover {
      background: var(--light);
      color: var(--dark);
    }
    &.active {
      background: var(--color);
      color: #fff;
    }
  }
}
.header {
  margin-top: 50px;
}

.layout {
  display: grid;
  grid-template-columns: 1fr 3fr;
  gap: 20px;
  text-align: left;
}

.items {
  display: grid;
  grid-auto-columns: var(--size);
  grid-auto-flow: column;
  gap: 20px;
  transition: 0.3s;
}

.image {
  padding-bottom: 60%;
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 10px;
}
.row {
  &:not(:last-child) {
    border-bottom: solid 1px var(--light);
  }
  padding: 10px 0;
}
.rows {
  margin-top: 30px;
  padding-left: 20px;
}
.value {
  word-break: break-word;
}
.button {
  background: var(--color);
  color: #fff;
  padding: 20px;
  cursor: pointer;
  border-radius: 6px;
  transition: 0.3s;
  text-align: center;
  justify-content: center;
  &:hover {
    transform: scale(1.05);
  }
}
.buttons {
  margin-top: 20px;
  text-align: center;
}

.remove {
  margin-top: 10px;
}
.only-mobile {
  display: none;
}
.label {
  display: none;
}
.items-wrapper {
  overflow: hidden;
}
.body {
  position: relative;
}
.navigation {
  position: absolute;
  right: -20px;
  top: 50%;
  transform: translateY(-50%);
  & > * {
    margin: 10px 0;
  }
}

@media screen and (max-width: 767px) {
  .title {
    font-size: 2.8em;
  }
  .layout {
    grid-template-columns: 1fr;
  }
  .field-name {
    display: none;
  }
  .item {
    .value {
      font-weight: 600;
    }
  }
  .items {
    grid-template-columns: unset;
    grid-auto-columns: 50vw;
    grid-auto-flow: column;
    padding-bottom: 20px;
    flex-shrink: 0;
  }
  .items-wrapper {
    overflow-x: scroll;
    padding: 0 15px;
    display: flex;
    &:after {
      content: '';
      display: block;
      width: 30px;
      height: 1px;
      background: var(--light);
      margin-top: 10px;
    }
  }
  .rows,
  .buttons {
    display: none;
  }
  .only-mobile,
  .label {
    display: block;
  }
  .ui-switcher-wrapper {
    padding: 0 15px;
  }
  .navigation {
    display: none;
  }
  .items {
    transform: none !important;
  }
}
</style>
